angular.module("vgresiduos").directive("disposalAttachments", function () {
	return {
		scope: true,
		controller: "DisposalAttachmentsCtrl",
		controllerAs: "ctrl",
		templateUrl: "views/destination/steps/disposalAttachments/disposalAttachments_template.html"
	};
});
